const LOWER = "abcdefghijklmnopqrstuvwxyz";
const UPPER = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
const DIGITS = "0123456789";
const SYMBOLS = "!@#$%^&*";

function secureIndex(length: number): number {
	const limit = 256 - (256 % length);
	const byte = new Uint8Array(1);
	let value: number;
	do {
		crypto.getRandomValues(byte);
		value = byte[0];
	} while (value >= limit);
	return value % length;
}

export function generateSipPassword(): string {
	const groups = [LOWER, UPPER, DIGITS, SYMBOLS];
	const all = groups.join("");
	const characters = groups.map((group) => group[secureIndex(group.length)]);
	while (characters.length < 16) {
		characters.push(all[secureIndex(all.length)]);
	}
	for (let index = characters.length - 1; index > 0; index--) {
		const swapIndex = secureIndex(index + 1);
		[characters[index], characters[swapIndex]] = [
			characters[swapIndex],
			characters[index],
		];
	}
	return characters.join("");
}
